import React, { useState } from 'react';

import { Button } from '@mui/material';

export default ({
  trpl,
  classes,
  trplIndex,
  children,
  isLastPossibleTrpl,
  removeAccordeonNode,
}) => {
  const [deleteLoading, setDeleteLoading] = useState(false);

  return (
    <div
      key={trpl.tid}
      className={`${classes.parentCustomBlock} ${classes.alignCenter}`}
      style={{
        borderBottom: isLastPossibleTrpl ? 'none' : '',
        pointerEvents: deleteLoading ? 'none' : '',
        opacity: deleteLoading ? '0.5' : ''
      }}
    >
      <div className={`delete-custom-block-mark`}>
        <Button
          size="small"
          className={`${classes.btnNormal} ${classes.trplBtn}`}
          style={{ minWidth: '20px', borderRadius: '10px', height: '20px', width: '20px', fontSize: 11, padding: 0, left: '-10px' }}
          onClick={() => {
            setDeleteLoading(true);
            removeAccordeonNode(trpl.tid, trpl.oid, trpl.pid, trplIndex, null, () => {
              setDeleteLoading(false);
            });
          }}
        >
          <span style={{ marginBottom: '2px' }}>
            &mdash;
          </span>
        </Button>
      </div>

      <div
        key={trpl.tid}
        className={`custom-trpl-block ${trplIndex > 0 ? classes.mt5 : classes.mt5} ${classes.fillAvailable}`}
      >
        {children}
      </div>
    </div>
  )
};
